// @ts-check

import BaseModel from "@kaspernj/api-maker/build/base-model.js"
import ElementFeedback from "./element-feedback.js"

const modelClassData = {
  "attributes": {
    "element_feedback_id": {
      "column": {
        "default": null,
        "name": "element_feedback_id",
        "null": false,
        "type": "uuid"
      },
      "name": "element_feedback_id",
      "selected_by_default": null,
      "translated": null
    },
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      },
      "name": "id",
      "selected_by_default": null,
      "translated": null
    },
    "option": {
      "column": {
        "default": null,
        "name": "option",
        "null": true,
        "type": "string"
      },
      "name": "option",
      "selected_by_default": null,
      "translated": null
    },
    "points": {
      "column": {
        "default": 0,
        "name": "points",
        "null": false,
        "type": "integer"
      },
      "name": "points",
      "selected_by_default": null,
      "translated": null
    },
    "position": {
      "column": {
        "default": 0,
        "name": "position",
        "null": false,
        "type": "integer"
      },
      "name": "position",
      "selected_by_default": null,
      "translated": null
    }
  },
  "className": "ElementFeedbackOption",
  "collectionKey": "element_feedback_options",
  "collectionName": "element_feedback_options",
  "i18nKey": "element_feedback_option",
  "camelizedLower": "elementFeedbackOption",
  "name": "ElementFeedbackOption",
  "nameDasherized": "element-feedback-option",
  "pluralName": "element_feedback_options",
  "ransackable_associations": [
    {
      "className": "Element",
      "collectionName": "elements",
      "foreignKey": "element_id",
      "name": "element",
      "macro": "has_one",
      "resource_name": "Element",
      "through": "element_feedback"
    },
    {
      "className": "ElementFeedback",
      "collectionName": "element_feedbacks",
      "foreignKey": "element_feedback_id",
      "name": "element_feedback",
      "macro": "belongs_to",
      "resource_name": "ElementFeedback",
      "through": null
    },
    {
      "className": "FeedbackAnswer",
      "collectionName": "feedback_answers",
      "foreignKey": "element_feedback_option_id",
      "name": "feedback_answers",
      "macro": "has_many",
      "resource_name": "FeedbackAnswer",
      "through": null
    },
    {
      "className": "FeedbackElement",
      "collectionName": "feedback_elements",
      "foreignKey": "feedback_element_id",
      "name": "feedback_elements",
      "macro": "has_many",
      "resource_name": "FeedbackElement",
      "through": "feedback_answers"
    },
    {
      "className": "Log",
      "collectionName": "logs",
      "foreignKey": "trackable_id",
      "name": "logs",
      "macro": "has_many",
      "resource_name": "Log",
      "through": null
    },
    {
      "className": "Tagging",
      "collectionName": "taggings",
      "foreignKey": "resource_id",
      "name": "taggings",
      "macro": "has_many",
      "resource_name": "Tagging",
      "through": null
    },
    {
      "className": "Tag",
      "collectionName": "tags",
      "foreignKey": "tag_id",
      "name": "tags",
      "macro": "has_many",
      "resource_name": "Tag",
      "through": "taggings"
    },
    {
      "className": "Tenant",
      "collectionName": "tenants",
      "foreignKey": "tenant_id",
      "name": "tenant",
      "macro": "belongs_to",
      "resource_name": "Tenant",
      "through": null
    },
    {
      "className": "WorkerPlugins::WorkplaceLink",
      "collectionName": "workplace_links",
      "foreignKey": "resource_id",
      "name": "workplace_links",
      "macro": "has_many",
      "resource_name": "WorkplaceLink",
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "element_feedback_id",
      "column": {
        "default": null,
        "name": "element_feedback_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "id_string",
      "column": null
    },
    {
      "name": "old_element_feedback_id",
      "column": {
        "default": null,
        "name": "old_element_feedback_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "old_id",
      "column": {
        "default": null,
        "name": "old_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "option",
      "column": {
        "default": null,
        "name": "option",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "points",
      "column": {
        "default": 0,
        "name": "points",
        "null": false,
        "type": "integer"
      }
    },
    {
      "name": "position",
      "column": {
        "default": 0,
        "name": "position",
        "null": false,
        "type": "integer"
      }
    },
    {
      "name": "tenant_id",
      "column": {
        "default": null,
        "name": "tenant_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    }
  ],
  "ransackable_scopes": [
    {
      "name": "in_current_workplace"
    },
    {
      "name": "soft_deleted_filter"
    },
    {
      "name": "sort_by_in_current_workplace_asc"
    },
    {
      "name": "sort_by_in_current_workplace_desc"
    }
  ],
  "relationships": [
    {
      "className": "ElementFeedback",
      "collectionName": "element_feedbacks",
      "foreignKey": "element_feedback_id",
      "name": "element_feedback",
      "macro": "belongs_to",
      "resource_name": "ElementFeedback",
      "through": null
    }
  ],
  "paramKey": "element_feedback_option",
  "primaryKey": "id"
}

/** Frontend model for ElementFeedbackOption. */
export default class ElementFeedbackOption extends BaseModel {
  /** @returns {typeof modelClassData} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {string} */
  elementFeedbackId() {
    return this.readAttributeUnderscore("element_feedback_id")
  }

  /** @returns {boolean} */
  hasElementFeedbackId() {
    const value = this.elementFeedbackId()

    return this._isPresent(value)
  }

  /** @returns {string} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  option() {
    return this.readAttributeUnderscore("option")
  }

  /** @returns {boolean} */
  hasOption() {
    const value = this.option()

    return this._isPresent(value)
  }

  /** @returns {number} */
  points() {
    return this.readAttributeUnderscore("points")
  }

  /** @returns {boolean} */
  hasPoints() {
    const value = this.points()

    return this._isPresent(value)
  }

  /** @returns {number} */
  position() {
    return this.readAttributeUnderscore("position")
  }

  /** @returns {boolean} */
  hasPosition() {
    const value = this.position()

    return this._isPresent(value)
  }

  /** @returns {import("./element-feedback.js").default | null} */
  elementFeedback() {
    return this._readBelongsToReflection({modelClass: ElementFeedback, reflectionName: "element_feedback"})
  }

  /** @returns {Promise<import("./element-feedback.js").default | null>} */
  loadElementFeedback() {
    if (!("elementFeedbackId" in this)) throw new Error("Foreign key method wasn't defined: elementFeedbackId")

    const id = this.elementFeedbackId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "element_feedback",
        model: this,
        modelClass: ElementFeedback
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./element-feedback.js").default | null>} */
  ensureElementFeedbackLoaded() {
    return this.ensureAssociationLoaded("element_feedback")
  }
}
